/**
 * Lifecycle of a city quest (street game).
 * Only `ready` is visible in the player catalog and playable.
 */
export enum CityQuestStatusEnum {
    DRAFT = 'draft',
    NEED_REVIEW = 'need_review',
    REJECTED = 'rejected',
    READY = 'ready',
    /** Hidden from catalog without deleting. */
    PAUSED = 'paused',
}
